import MappingOriginOption from "~/models/mapping/mappingOriginOption";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import {IMappingOriginOptionOpts} from "~/interfaces/mappingInterfaces";
import {Logger} from "~/services/logger";

export default class MappingOriginOptionFormElement extends MappingOriginOption<FormElement> {
  ORIGIN_TYPE: 'formElement' = 'formElement'
  type: 'single' | 'multi'

  constructor(opts: IMappingOriginOptionOpts<FormElement>) {
    super(opts)
    if (opts.type) {
      this.type = opts.type
    } else {
      Logger.errorOnce('MappingOriginOptionFormElement', 'Type not provided. Please provide an type ("single" or "multi").')
    }
  }

  get title(): string {
    let title: string = this.origin.defaultLabelTitle
    const closestRepeatableAncestor = this.origin.repeatableAncestors[0]
    if (closestRepeatableAncestor) {
      title += ` (Nested: ${closestRepeatableAncestor.defaultLabelTitle})`
    }
    return title
  }

  get id(): string {
    return this.origin.client_id
  }
}
